import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleAddResourceToResourceGroupRequest(
  state: State,
  { group, resource }: Boundaries["addResourceToResourceGroup"]["request"],
) {
  const index = state.findIndex(
    (req) =>
      req.group.uuid === group.uuid && resource.uuid === req.resource.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { group, resource, requestState: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { group, resource, requestState: setRequestStateToPending() }];
}

function handleAddResourceToResourceGroupSuccess(
  state: State,
  { group, resource }: Boundaries["addResourceToResourceGroup"]["success"],
) {
  const index = state.findIndex(
    (req) =>
      req.group.uuid === group.uuid && resource.uuid === req.resource.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { group, resource, requestState: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { group, resource, requestState: setRequestStateToSuccess() }];
}

function handleAddResourceToResourceGroupFailure(
  state: State,
  { group, resource }: Boundaries["addResourceToResourceGroup"]["failure"],
) {
  const index = state.findIndex(
    (req) =>
      req.group.uuid === group.uuid && resource.uuid === req.resource.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { group, resource, requestState: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { group, resource, requestState: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.addResourceToResourceGroupRequested]:
      handleAddResourceToResourceGroupRequest,
    [events.addResourceToResourceGroupSucceeded]:
      handleAddResourceToResourceGroupSuccess,
    [events.addResourceToResourceGroupFailed]:
      handleAddResourceToResourceGroupFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
